var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserNoImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0017 24.3382C27.0659 24.3382 29.5708 21.8333 29.5708 18.7691C29.5708 15.7048 27.0659 13.2 24.0017 13.2C20.9374 13.2 18.4326 15.7048 18.4326 18.7691C18.4326 21.8333 20.9375 24.3382 24.0017 24.3382Z",
    fill: "#065A8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5594 28.7886C33.4134 28.4238 33.2189 28.0833 33 27.7672C31.8813 26.1135 30.1547 25.0191 28.2091 24.7516C27.966 24.7273 27.6985 24.7759 27.5039 24.9218C26.4825 25.6757 25.2665 26.0648 24.0019 26.0648C22.7373 26.0648 21.5213 25.6757 20.4999 24.9218C20.3053 24.7759 20.0378 24.7029 19.7946 24.7516C17.8491 25.0191 16.0981 26.1135 15.0038 27.7672C14.7849 28.0833 14.5903 28.4481 14.4444 28.7886C14.3715 28.9345 14.3958 29.1048 14.4687 29.2507C14.6633 29.5911 14.9065 29.9316 15.1254 30.2235C15.4658 30.6856 15.8306 31.0989 16.2441 31.488C16.5845 31.8285 16.9736 32.1447 17.3628 32.4608C19.284 33.8957 21.5943 34.6495 23.9776 34.6495C26.3609 34.6495 28.6712 33.8956 30.5924 32.4608C30.9815 32.169 31.3706 31.8285 31.7111 31.488C32.1002 31.0989 32.4893 30.6855 32.8298 30.2235C33.073 29.9073 33.2919 29.5911 33.4865 29.2507C33.608 29.1048 33.6323 28.9345 33.5594 28.7886Z",
    fill: "#065A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNoImage);
export default __webpack_public_path__ + "static/media/user-no-image.2e5dbc1924970a2a1726d6e0f2cc391e.svg";
export { ForwardRef as ReactComponent };